import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { TransferCurrentNavigation, TransferDetailsType, TransferFilterModel, TransferStatusWorkflow, createTransferData } from '../types';
import Transfer from '@/model/transfer.mjs';
import { AgGridReact } from 'ag-grid-react';
import { SortModelItem } from 'ag-grid-community';
import Licensee from '@/model/licensee.mjs';
import { ezCheckHistoryItem } from '@/model/explore';
import { LicenseDetail } from '@/model/builders/ffl-get-license-details.mjs';

export interface ValidLicenseRecord {
  fullLicenseKeys?: string[];
  licenseKey?: string | null;
  dealerId?: string | null;
  recordNotFound?: boolean | null;
}

export interface QueueState {
  createTransferData: Transfer | null;
  isEzCheckInprogress: boolean;
  isEzCheckInCompleted: boolean;
  isEZCheckForTransferCreationInProgress: boolean;
  isTransferCreationAllowed: boolean;
  ezCheckStatusTransferCreation: string | null;
  isTransferReinitiateAllowed: boolean;
  isFetchingTransferStatusWorkflow: boolean;
  transferStatusWorkflow: Array<TransferStatusWorkflow>;
  inboundTransferStatusWorkflow: Array<TransferStatusWorkflow>;
  transferSuggestion: string;
  ezCheckTransferCreationError: string | null
  sequalizeValidationError: string | null;
  totalTransfersCount: number;
  transferFilterModel: TransferFilterModel;
  isRefreshingTransfers: boolean;
  isRefreshingTransferStatus: boolean;
  isRefreshingInboundTransferStatus: boolean;
  agGridTransferSortModel: SortModelItem[];
  isLoadingTransferExcelGeneration: boolean;
  isExportTransferReportButtonDisabled: boolean
  isUpdatingTransferForArchive: boolean;
  isTransferForArchiveUpdated: boolean;
  transferCurrentNavigation: TransferCurrentNavigation;
  StoreNames: StoreNameType[];
  storeNameLists: StoreNameType[];
  SourceDescriptions: StoreNameType[];
  sourceDescriptionLists: StoreNameType[];
  isTransferDetailsLoading: boolean;
  transferDetails: TransferDetailsType | null;
  transferRecieverDetails: LicenseDetail | null;
  transferSellerDetails: LicenseDetail | null;
  isLoadingTransferOtherDetails: boolean;
  transferRecieverEZDetails: ezCheckHistoryItem | null;
  transferSellerEZDetails: ezCheckHistoryItem | null;
  transferSearchText: string;
  isResendingInitiationEmail: boolean;
  isInboundActionInprogress: boolean;
  isAssigningTransferDealer: boolean;
  isAssigningTransferDealerComplete: boolean;
  historyPanelData: Array<TransferStatusWorkflow>;
  isFetchingHistoryPanelData: boolean;
  transferDealerHistory: Array<Licensee>;
  isTransferDealrHistoryLoading: boolean;
  transferCount: number;
  transferQueueLoading: boolean;
  licenseeDetail: Licensee | null
  sendEmailToCustomerStatus: string;
  sendEmailToCustomerLoading: boolean;
  isGenerateMasterProofLoading: boolean;
  generateMasterProofStatus: string;
  documentsRequiredDetails: any
  reassignDealerHistory: any
  reAssignMicroHistory: any[]
  isReAssignMicroHistoryLoading: boolean
  isLoadingTransferFilters: boolean
  transferFilterPreferencesLoaded: boolean
  isRemoveFiltersLoading: boolean
  isClearAllFilterClickedOnTransfer: boolean
  isRemoveAnyFilter: boolean,
  permissionList: any,
  isPermissionsLoading: boolean,
  isPermissionUpdateLoading: boolean,
  permissionConfig: any,
  isPermissionReset: boolean,
  isPermissionChanged: boolean,
  ecommerceStatus: StoreNameType[];
  eccomerceStatusFilterList: StoreNameType[];
  sellerLicenseKeyLists: Array<AutoCompleteApiObject>;
  isDetailsRefresh: boolean,
  isDealerDetailsLoading: boolean;
  isMasterProofTimeOut: boolean,
  isSkipStepLoading: boolean,
  isSkipStepSuccess: boolean,
  isGetEmailTemplateLoading: boolean,
  emailTamplete: any,
  validLicenseRecordDetails: ValidLicenseRecord | null,
  documentsRequiredDetailsLoading: boolean,
  autoCompleteData: Array<AutoCompleteApiObject>,
  transferFilterCollection: any[]
  isTransferFilterCollectionLoading: boolean
  transferFilterSaveSuccessName: string | null
  /** True when an existing collection was saved (update); false for new filter save. */
  transferFilterSaveSuccessIsUpdate: boolean
  transferFilterDeleteSuccessName: string | null
  /** Persisted saved-filter dropdown selection (survives filter panel close / unmount). */
  selectedSavedTransferFilter: { value: string; label: string } | null
  skipDefaultTransferQueueFilterAutoApply: boolean
  // inboundDealerId: string | null

}

export interface AutoCompleteApiObject {
  dealerId: string,
  businessName: string,
  licenseName: string,
  shortLicenseNumber: string
  shortLicenseNumberWithHyphen: string
  city: string,
  state: string
}
export interface StoreNameType {
  label: string,
  value: string,
}
export interface TransferSeachModelInterface {
  search: string | null
}

export interface ezCheckInitiateTransfer {
  license_key: string | undefined;
  isReinitiate?: boolean
}

const initialState: QueueState = {
  createTransferData: null,
  isEzCheckInprogress: false,
  isEzCheckInCompleted: false,
  isEZCheckForTransferCreationInProgress: false,
  isTransferCreationAllowed: false,
  ezCheckStatusTransferCreation: null,
  isTransferReinitiateAllowed: false,
  isFetchingTransferStatusWorkflow: false,
  transferStatusWorkflow: [],
  inboundTransferStatusWorkflow: [],
  transferSuggestion: "",
  ezCheckTransferCreationError: null,
  sequalizeValidationError: null,
  transferFilterModel: {
    agent: { filterType: "set", values: [] }, firearm: { filterType: "set", values: [] }, storeName: { filterType: "set", values: [] }, source: { filterType: "set", values: [] }, ecommerce_status: { filterType: "set", values: [] }, transferType: { filterType: "set", values: [] }, derivedStatus: { filterType: "set", values: [] }, "licensee.id": { filterType: "text", type: "equals", filter: "" }, referenceId: { filterType: "text", type: "contains", filter: "" }, sellerLicenseKey: { filterType: "set", values: [] }, searchText: { filterType: "text", type: "contains", filter: "" }, microStatus: { filterType: "set", values: [] }, createdAt: { filterType: "date", type: "inRange", dateFrom: "", dateTo: "" }, is_external: {
      filterType: 'set', values: []
    }, isArchive: { filterType: 'set', values: [] }, linkedTransfers: { filterType: 'set', values: [] }
  },
  totalTransfersCount: 0,
  isRefreshingTransfers: false,
  isRefreshingTransferStatus: false,
  isRefreshingInboundTransferStatus: false,
  agGridTransferSortModel: [],
  isLoadingTransferExcelGeneration: false,
  isExportTransferReportButtonDisabled: true,
  isTransferForArchiveUpdated: false,
  isUpdatingTransferForArchive: false,
  transferCurrentNavigation: TransferCurrentNavigation.TRANSFER_QUEUE,
  StoreNames: [],
  storeNameLists: [],
  SourceDescriptions: [],
  sourceDescriptionLists: [],
  isTransferDetailsLoading: false,
  transferDetails: null,
  transferRecieverDetails: null,
  transferSellerDetails: null,
  isLoadingTransferOtherDetails: false,
  transferSellerEZDetails: null,
  transferRecieverEZDetails: null,
  transferSearchText: "",
  isResendingInitiationEmail: false,
  isInboundActionInprogress: false,
  isAssigningTransferDealer: false,
  isAssigningTransferDealerComplete: false,
  historyPanelData: [],
  isFetchingHistoryPanelData: false,
  transferDealerHistory: [],
  isTransferDealrHistoryLoading: false,
  transferCount: 0,
  transferQueueLoading: false,
  licenseeDetail: null,
  sendEmailToCustomerStatus: '',
  sendEmailToCustomerLoading: false,
  isGenerateMasterProofLoading: false,
  generateMasterProofStatus: '',
  documentsRequiredDetails: {},
  reassignDealerHistory: [],
  reAssignMicroHistory: [],
  isReAssignMicroHistoryLoading: false,
  isLoadingTransferFilters: false,
  transferFilterPreferencesLoaded: false,
  isRemoveFiltersLoading: false,
  isClearAllFilterClickedOnTransfer: false,
  isRemoveAnyFilter: false,
  permissionList: {},
  isPermissionsLoading: false,
  isPermissionUpdateLoading: false,
  permissionConfig: {},
  isPermissionReset: false,
  isPermissionChanged: false,
  ecommerceStatus: [],
  eccomerceStatusFilterList: [],
  sellerLicenseKeyLists: [],
  isDetailsRefresh: false,
  isDealerDetailsLoading: false,
  isMasterProofTimeOut: false,
  isSkipStepLoading: false,
  isSkipStepSuccess: false,
  isGetEmailTemplateLoading: false,
  emailTamplete: null,
  validLicenseRecordDetails: {},
  documentsRequiredDetailsLoading: false,
  autoCompleteData: [],
  transferFilterCollection: [],
  isTransferFilterCollectionLoading: false,
  transferFilterSaveSuccessName: null,
  transferFilterSaveSuccessIsUpdate: false,
  transferFilterDeleteSuccessName: null,
  selectedSavedTransferFilter: null,
  skipDefaultTransferQueueFilterAutoApply: false
  // inboundDealerId: null
}

export const QueueSlice = createSlice({
  name: 'queue',
  initialState,
  reducers: {
    setCreateTransferData: (state, action: PayloadAction<Transfer | null>) => {
      state.createTransferData = action.payload
    },
    setStoreNameLists: (state, action: PayloadAction<StoreNameType[]>) => {
      state.storeNameLists = action.payload;
    },
    setSourceDescriptionLists: (state, action: PayloadAction<StoreNameType[]>) => {
      state.sourceDescriptionLists = action.payload;
    },
    setIsEzCheckInprogress: (state, action: PayloadAction<boolean>) => {
      state.isEzCheckInprogress = action.payload
    },
    setIsEzCheckInCompleted: (state, action: PayloadAction<boolean>) => {
      state.isEzCheckInCompleted = action.payload
    },
    setIsEZCheckForTransferCreationInProgress: (state, action: PayloadAction<boolean>) => {
      state.isEZCheckForTransferCreationInProgress = action.payload
    },
    setisTransferCreationAllowed: (state, action: PayloadAction<boolean>) => {
      state.isTransferCreationAllowed = action.payload
    },
    setIsTransferReinitiateAllowed: (state, action: PayloadAction<boolean>) => {
      state.isTransferReinitiateAllowed = action.payload
    },
    setEZCheckStatusTransferCreation: (state, action: PayloadAction<string | null>) => {
      state.ezCheckStatusTransferCreation = action.payload
    },
    setIsFetchingTransferStatusWorkflow: (state, action: PayloadAction<boolean>) => {
      state.isFetchingTransferStatusWorkflow = action.payload
    },
    setTransferStatusWorkflow: (state, action: PayloadAction<Array<TransferStatusWorkflow>>) => {
      state.transferStatusWorkflow = action.payload
    },
    setLicenseeDetail: (state, action: PayloadAction<Licensee | null>) => {
      state.licenseeDetail = action.payload
    },
    setInboundTransferStatusWorkflow: (state, action: PayloadAction<Array<TransferStatusWorkflow>>) => {
      state.inboundTransferStatusWorkflow = action.payload
    },
    setTransferSuggestion: (state, action: PayloadAction<string>) => {
      state.transferSuggestion = action.payload
    },
    callToEZCheckValidator: (state, action: PayloadAction<any>) => {
    },
    callToEZCheckForTransferCreation: (state, action: PayloadAction<ezCheckInitiateTransfer>) => {
    },
    callToGetStoreNames: (state, action: PayloadAction<any>) => {
    },
    callToGetSourceDescriptions: (state, action: PayloadAction<any>) => {
    },
    callToGetStoreFilterConfigData: (state, action: PayloadAction<any>) => { },
    setStoreNames: (state, action: PayloadAction<StoreNameType[]>) => {
      state.StoreNames = action.payload
    },
    setSourceDescriptions: (state, action: PayloadAction<StoreNameType[]>) => {
      state.SourceDescriptions = action.payload
    },
    setEZCheckForTransferCreationMessage: (state, action: PayloadAction<string | null>) => {
      state.ezCheckTransferCreationError = action.payload
    },
    callToGetTransferStatusWorkFlow: (state, action: PayloadAction<{ id: string }>) => { },
    setSequalizeValidationError: (state, action: PayloadAction<string | null>) => {
      state.sequalizeValidationError = action.payload
    },
    setTotalTransfersCount: (state, action: PayloadAction<number>) => {
      state.totalTransfersCount = action.payload
    },
    setTransferFilterModel: (state, action: PayloadAction<TransferFilterModel>) => {
      state.transferFilterModel = action.payload
    },
    setIsRefreshingTransfers: (state, action: PayloadAction<boolean>) => {
      state.isRefreshingTransfers = action.payload
    },
    setIsRefreshingTransferStatus: (state, action: PayloadAction<boolean>) => {
      state.isRefreshingTransferStatus = action.payload
    },
    setIsRefreshingInboundTransferStatus: (state, action: PayloadAction<boolean>) => {
      state.isRefreshingInboundTransferStatus = action.payload
    },
    downloadTransferListForExcel: (state, action: PayloadAction<React.RefObject<AgGridReact<Transfer>>>) => { },
    setTransferGridSortModel: (state, action: PayloadAction<SortModelItem[]>) => {
      state.agGridTransferSortModel = action.payload
    },
    setIsLoadingTransferExcelGeneration: (state, action: PayloadAction<boolean>) => {
      state.isLoadingTransferExcelGeneration = action.payload
    },
    setIsExportTransferReportButtonDisabled: (state, action: PayloadAction<boolean>) => {
      state.isExportTransferReportButtonDisabled = action.payload
    },
    callToUpdateTransferArchive: (state, action: PayloadAction<{ isArchive: boolean, id: string }>) => {
    },
    setIsTransferForArchiveUpdated: (state, action: PayloadAction<boolean>) => {
      state.isTransferForArchiveUpdated = action.payload
    },
    setIsUpdatingTransferForArchive: (state, action: PayloadAction<boolean>) => {
      state.isUpdatingTransferForArchive = action.payload
    },
    setTransferCurrentNavigation: (state, action: PayloadAction<TransferCurrentNavigation>) => {
      state.transferCurrentNavigation = action.payload
    },
    callToGetTransferDetails: (state, action: PayloadAction<{ id: string; isRefresh?: boolean }>) => { },
    setIsTransferDetailsLoading: (state, action: PayloadAction<boolean>) => {
      state.isTransferDetailsLoading = action.payload
    },
    setTtransferDetails: (state, action: PayloadAction<TransferDetailsType | null>) => {
      state.transferDetails = action.payload
    },
    setTransferSellerDetails: (state, action: PayloadAction<LicenseDetail | null>) => {
      state.transferSellerDetails = action.payload
    },
    setTransferRecieverDetails: (state, action: PayloadAction<LicenseDetail | null>) => {
      state.transferRecieverDetails = action.payload
    },
    setisLoadingTransferOtherDetails: (state, action: PayloadAction<boolean>) => {
      state.isLoadingTransferOtherDetails = action.payload
    },
    callInBoundTransferAction: (state, action: PayloadAction<{ action: string, id: string }>) => { },
    setTransferRecieverEZDetails: (state, action: PayloadAction<ezCheckHistoryItem | null>) => {
      state.transferRecieverEZDetails = action.payload
    },
    setTransferSellerEZDetails: (state, action: PayloadAction<ezCheckHistoryItem | null>) => {
      state.transferSellerEZDetails = action.payload
    },
    setTransferSearchText: (state, action: PayloadAction<string>) => {
      state.transferSearchText = action.payload;
    },
    setIsResendingInitiationEmail: (state, action: PayloadAction<boolean>) => {
      state.isResendingInitiationEmail = action.payload;
    },
    callToResendIinitiationEmail: (state, action: PayloadAction<{ transferId: string }>) => {
    },
    callToGenerateMasterProof: (state, action: PayloadAction<{ transferId: string }>) => {
    },
    setIsInboundActionInprogress: (state, action: PayloadAction<boolean>) => {
      state.isInboundActionInprogress = action.payload;
    },
    setIsAssigningTransferDealer: (state, action: PayloadAction<boolean>) => {
      state.isAssigningTransferDealer = action.payload;
    },
    setIsAssigningTransferDealerComplete: (state, action: PayloadAction<boolean>) => {
      state.isAssigningTransferDealerComplete = action.payload;
    },
    callToAssignTransferDealer: (state, action: PayloadAction<{ transferId: string, licenseKey: string, reason?: string }>) => {

    },
    callToAssignTransferLicense: (state, action: PayloadAction<{ licenseKey: string }>) => {
    },
    setHistoryPanelData: (state, action: PayloadAction<{ transferStatusWorkflow: Array<TransferStatusWorkflow> }>) => {
      state.historyPanelData = action.payload.transferStatusWorkflow
    },
    setIsFetchingHistoryPanelData: (state, action: PayloadAction<boolean>) => {
      state.isFetchingHistoryPanelData = action.payload;
    },
    setTransferDealerHistory: (state, action: PayloadAction<Array<Licensee>>) => {
      state.transferDealerHistory = action.payload
    },
    callToGetTransferDealerHistory: (state, action: PayloadAction<{ transferId: string }>) => {
    },
    setIsTransferDealrHistoryLoading: (state, action: PayloadAction<boolean>) => {
      state.isTransferDealrHistoryLoading = action.payload
    },
    setTransferCount: (state, action: PayloadAction<number>) => {
      state.transferCount = action.payload
    },
    setTransferQueueLoading: (state, action: PayloadAction<boolean>) => {
      state.transferQueueLoading = action.payload
    },
    callToSendCustomerAssignDealerMail: (state, action: PayloadAction<{ transferId: string }>) => {
    },
    setSendEmailToCustomerStatus: (state, action: PayloadAction<string>) => {
      state.sendEmailToCustomerStatus = action.payload
    },
    setSendEmailToCustomerLoading: (state, action: PayloadAction<boolean>) => {
      state.sendEmailToCustomerLoading = action.payload
    },
    setIsGenerateMasterProofLoading: (state, action: PayloadAction<boolean>) => {
      state.isGenerateMasterProofLoading = action.payload
    },
    setGenerateMasterProofStatus: (state, action: PayloadAction<string>) => {
      state.generateMasterProofStatus = action.payload
    },
    setDocumentsRequiredDetails: (state, action: PayloadAction<any>) => {
      state.documentsRequiredDetails = action.payload
    },
    setValidLicenseRecord: (state, action: PayloadAction<any>) => {
      state.validLicenseRecordDetails = action.payload;
    },
    setAutoCompleteDataResult: (state, action: PayloadAction<any>) => {
      state.autoCompleteData = action.payload
    },
    setReAssignHistory: (state, action: PayloadAction<any>) => {
      state.reassignDealerHistory = action.payload
    },
    callToGetReAssignMicroHistory: (state, action: PayloadAction<any>) => { },
    callToUpdateTransferDetails: (state, action: PayloadAction<any>) => { },
    callToRemoveTransferFilters: () => { },
    callToGetTransferFilters: () => { },
    setReAssignMicroHistory: (state, action: PayloadAction<any>) => {
      state.reAssignMicroHistory = action.payload
    },
    setIsReAssignMicroHistoryLoading: (state, action: PayloadAction<boolean>) => {
      state.isReAssignMicroHistoryLoading = action.payload
    },
    setIsTransferFiltersLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoadingTransferFilters = action.payload;
    },
    setTransferFilterPreferencesLoaded: (state, action: PayloadAction<boolean>) => {
      state.transferFilterPreferencesLoaded = action.payload;
    },
    setIsRemoveTransferFiltersLoading: (state, action: PayloadAction<boolean>) => {
      state.isRemoveFiltersLoading = action.payload;
    },
    setIsClearAllFilterClickedOnTransfer: (state, action: PayloadAction<boolean>) => {
      state.isClearAllFilterClickedOnTransfer = action.payload
    },
    setIsRemoveAnyFilter: (state, action: PayloadAction<boolean>) => {
      state.isRemoveAnyFilter = action.payload
    },
    callToGetReAssignDealerHistory: (state, action: PayloadAction<any>) => { },
    callToGetPermissionsTabsList: () => { },
    setPermissionsTabList: (state, action: PayloadAction<any>) => {
      state.permissionList = action.payload
    },
    setIsPermissionsLoading: (state, action: PayloadAction<boolean>) => {
      state.isPermissionsLoading = action.payload
    },
    callToUpdatePermissionsTabsList: (state, action: PayloadAction<any>) => { },

    setIsPermissionUpdateLoading: (state, action: PayloadAction<boolean>) => {
      state.isPermissionUpdateLoading = action.payload
    },
    setPermissionConfig: (state, action: PayloadAction<any>) => {
      state.permissionConfig = action.payload
    },
    setIsPermissionReset: (state, action: PayloadAction<boolean>) => {
      state.isPermissionReset = action.payload
    },
    setIsPermissionChanged: (state, action: PayloadAction<boolean>) => {
      state.isPermissionChanged = action.payload
    },
    callToGetEcommerceStatus: (state, action: PayloadAction<any>) => { },
    callToGetAutoCompleteApiResult: (state, action: PayloadAction<any>) => {},
    setEcommerceStatusData: (state, action: PayloadAction<any>) => {
      state.ecommerceStatus = action.payload
    },
    setEccomerceStatusFilterLists: (state, action: PayloadAction<StoreNameType[]>) => {
      state.eccomerceStatusFilterList = action.payload;
    },
    setSellerLicenseKeyLists: (state, action: PayloadAction<Array<AutoCompleteApiObject>>) => {
      state.sellerLicenseKeyLists = action.payload;
    },
    callToGetDocumentStatus: (state, action:PayloadAction<any>) => { },
    callToGetLicenseRecordDetails: (state, action:PayloadAction<any>) => { },
    callToGetSellerDetails: (state, action:PayloadAction<any>) => { },
    callToGetRecieverDetails: (state, action:PayloadAction<any>) => { },
    setIsDetailsRefresh: (state,action: PayloadAction<boolean>) => {
      state.isDetailsRefresh = action.payload
    },
    setIsDealerDetailsLoading: (state, action: PayloadAction<boolean>) => {
      state.isDealerDetailsLoading = action.payload
    },
    setIsMasterProofTimeOut: (state, action: PayloadAction<boolean>) => {
      state.isMasterProofTimeOut = action.payload;
    },
    callToSkipStep: (state, action: PayloadAction<{ transferId: string }>) => {
    },
    setIsSkipStepLoading: (state, action: PayloadAction<boolean>) => {
      state.isSkipStepLoading = action.payload;
    },
    setIsSkipStepSuccess: (state, action: PayloadAction<boolean>) => {
      state.isSkipStepSuccess = action.payload;
    },
    callToGetEmailTemplate: (state, action: PayloadAction<{ emailId: string }>) => {
    },
    setIsGetEmailTemplateLoading: (state, action: PayloadAction<boolean>) => {
      state.isGetEmailTemplateLoading = action.payload;
    },
    setEmailTamplate: (state, action: PayloadAction<any>) => {
      state.emailTamplete = action.payload;
    },
    setDocumentsRequiredDetailsLoading: (state, action: PayloadAction<boolean>) => {
      state.documentsRequiredDetailsLoading = action.payload;
    },
    // setInboundDealerId:  (state, action: PayloadAction<string | null>) => {
    //   state.inboundDealerId = action.payload;
    // },

    setTransferFilterCollection: (state, action: PayloadAction<any[]>) => {
      state.transferFilterCollection = action.payload
    },
    callToSaveTransferFilterCollection: (state, action: PayloadAction<any>) => {
    },
    callToDeleteTransferFilterCollection: (
      state,
      action: PayloadAction<{ id: string; name: string }>
    ) => {},
    callToGetTransferFilterCollection: () => {},
    setTransferFilterCollectionLoading: (state, action: PayloadAction<boolean>) => {
      state.isTransferFilterCollectionLoading = action.payload
    },
    setTransferFilterSaveSuccess: (
      state,
      action: PayloadAction<{ name: string; isUpdate: boolean } | null>
    ) => {
      if (action.payload === null) {
        state.transferFilterSaveSuccessName = null;
        state.transferFilterSaveSuccessIsUpdate = false;
      } else {
        state.transferFilterSaveSuccessName = action.payload.name;
        state.transferFilterSaveSuccessIsUpdate = action.payload.isUpdate;
      }
    },
    setTransferFilterDeleteSuccessName: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.transferFilterDeleteSuccessName = action.payload
    },
    setSelectedSavedTransferFilter: (
      state,
      action: PayloadAction<{ value: string; label: string } | null>
    ) => {
      if (action.payload === null && !state.isClearAllFilterClickedOnTransfer) {
        return;
      }
      state.selectedSavedTransferFilter = action.payload
    },
    setSkipDefaultTransferQueueFilterAutoApply: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.skipDefaultTransferQueueFilterAutoApply = action.payload;
    },
  },
})

export const {
  setCreateTransferData,
  setIsEzCheckInprogress,
  setIsEzCheckInCompleted,
  setIsEZCheckForTransferCreationInProgress,
  setisTransferCreationAllowed,
  setIsTransferReinitiateAllowed,
  setLicenseeDetail,
  setEZCheckStatusTransferCreation,
  setIsFetchingTransferStatusWorkflow,
  setTransferStatusWorkflow,
  setInboundTransferStatusWorkflow,
  setTransferSuggestion,
  setTransferFilterModel,
  setEZCheckForTransferCreationMessage,
  setSequalizeValidationError,
  setTotalTransfersCount,
  setIsUpdatingTransferForArchive,
  setIsTransferForArchiveUpdated,
  setStoreNames,
  setStoreNameLists,
  setSourceDescriptions,
  setSourceDescriptionLists,
  setIsTransferDetailsLoading,
  setTtransferDetails,
  setTransferRecieverDetails,
  setTransferSellerDetails,
  setisLoadingTransferOtherDetails,
  setTransferRecieverEZDetails,
  setTransferSellerEZDetails,
  setTransferSearchText,
  setIsResendingInitiationEmail,
  setIsRefreshingTransfers,
  setIsRefreshingTransferStatus,
  setIsRefreshingInboundTransferStatus,
  setTransferGridSortModel,
  setIsLoadingTransferExcelGeneration,
  setIsExportTransferReportButtonDisabled,
  setIsInboundActionInprogress,
  setIsAssigningTransferDealer,
  setIsAssigningTransferDealerComplete,
  setHistoryPanelData,
  setIsFetchingHistoryPanelData,
  setTransferDealerHistory,
  setIsTransferDealrHistoryLoading,
  setIsTransferFiltersLoading,
  setTransferFilterPreferencesLoaded,
  setIsRemoveTransferFiltersLoading,
  // Saga actions
  callToEZCheckValidator,
  callToEZCheckForTransferCreation,
  callToGetTransferStatusWorkFlow,
  callToGetStoreNames,
  callToGetSourceDescriptions,
  callToGetStoreFilterConfigData,
  callToUpdateTransferArchive,
  setTransferCurrentNavigation,
  callInBoundTransferAction,
  callToGetTransferDetails,
  callToResendIinitiationEmail,
  callToGenerateMasterProof,
  downloadTransferListForExcel,
  callToAssignTransferDealer,
  callToAssignTransferLicense,
  callToGetTransferDealerHistory,
  setTransferCount,
  setTransferQueueLoading,
  callToSendCustomerAssignDealerMail,
  setSendEmailToCustomerStatus,
  setSendEmailToCustomerLoading,
  setIsGenerateMasterProofLoading,
  setGenerateMasterProofStatus,
  setDocumentsRequiredDetails,
  setReAssignHistory,
  callToGetReAssignMicroHistory,
  callToUpdateTransferDetails,
  callToRemoveTransferFilters,
  callToGetTransferFilters,
  setReAssignMicroHistory,
  setIsReAssignMicroHistoryLoading,
  setIsClearAllFilterClickedOnTransfer,
  setIsRemoveAnyFilter,
  callToGetReAssignDealerHistory,
  callToGetPermissionsTabsList,
  setPermissionsTabList,
  setIsPermissionsLoading,
  callToUpdatePermissionsTabsList,
  setIsPermissionUpdateLoading,
  setPermissionConfig,
  setIsPermissionReset,
  setIsPermissionChanged,
  callToGetEcommerceStatus,
  callToGetAutoCompleteApiResult,
  setEcommerceStatusData,
  setEccomerceStatusFilterLists,
  setSellerLicenseKeyLists,
  callToGetLicenseRecordDetails,
  callToGetSellerDetails,
  callToGetRecieverDetails,
  setIsDetailsRefresh,
  setIsDealerDetailsLoading,
  setIsMasterProofTimeOut,
  callToSkipStep,
  setIsSkipStepLoading,
  setIsSkipStepSuccess,
  callToGetEmailTemplate,
  setIsGetEmailTemplateLoading,
  setEmailTamplate,
  setDocumentsRequiredDetailsLoading,
  setValidLicenseRecord,
  setAutoCompleteDataResult,
  callToGetDocumentStatus,
  setTransferFilterCollection,
  callToSaveTransferFilterCollection,
  callToDeleteTransferFilterCollection,
  callToGetTransferFilterCollection,
  setTransferFilterCollectionLoading,
  setTransferFilterSaveSuccess,
  setTransferFilterDeleteSuccessName,
  setSelectedSavedTransferFilter,
  setSkipDefaultTransferQueueFilterAutoApply,
  // setInboundDealerId
} = QueueSlice.actions

export default QueueSlice.reducer
